module.exports = __webpack_public_path__ + "img/presenter-modal-bg.8322cf85.png";